import { Component, OnInit } from '@angular/core';

// Importaciones de servicios.
import { ProductService } from '../../services/product.service';

// Importaciones de interfaces.
import { IProduct } from '../../interfaces/product.interface';
import { IProductResponse } from '../../interfaces/product-response.interface';

// Importaciones de modelos.
import { Product } from '../../models/product.model';

/**
 * Componente de activaciones.
 *
 * Este componente muestra una lista de productos,
 * permitiendo acceder a ellos para crear una activación del producto en concreto.
 */
@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  standalone: false,
})
export class ProductsComponent implements OnInit {
  /**
   * Indica si la lista de productos se está cargando.
   * Se utiliza para mostrar un indicador de carga en la interfaz de usuario.
   */
  loading: boolean = false;

  /**
   * Array que almacena la lista de productos obtenidos desde el servicio.
   */
  products: IProduct[] = [];

  /**
   * Constructor del componente.
   *
   * @param productService - Servicio utilizado para obtener la lista de productos.
   */
  constructor(private productService: ProductService) {}

  /**
   * Método de inicialización del componente.
   *
   * Obtiene la lista de productos desde el servicio y los almacena en la variable `products`.
   * Maneja posibles errores y muestra un indicador de carga mientras se realiza la petición.
   */
  async ngOnInit(): Promise<void> {
    this.loading = true;

    try {
      const productResponse: IProductResponse =
        await this.productService.getAll(0);
      this.products = productResponse.products.map(
        (product: IProduct) => new Product(product)
      );
    } finally {
      this.loading = false;
    }
  }
}
